export const PAGE_SIZES = [50, 100, 200, 500, 1000, 1500, 2000];

export function formatDateTime(iso) {
  if (!iso) return '';
  const str = String(iso);
  // 如果不帶時區資訊，視為 UTC（加上 Z）
  const normalized = str.match(/[Z+\-]\d{0,4}:?\d{0,2}$/) ? str : str + 'Z';
  const d = new Date(normalized);
  return isNaN(d) ? '' : d.toLocaleString('zh-TW', { timeZone: 'Asia/Singapore' });
}
